<!-- eslint-disable eqeqeq -->
<!-- eslint-disable eqeqeq -->
<template>
  <div>
    <div class="w-100 d-flex py-1 px-5"  style="background-color:var(--cor-primaria);">
      <div class="d-flex w-lg-75 w-100 mx-auto" style="justify-content: space-between;">
        <div class="d-flex" style="gap:20px; display: none;">
          <div class="d-lg-flex flex-row" style="gap:20px; display: none;">
            <a aria-label="Telefone Primeseg" href="tel:+553336413038" class="d-flex flex-row link" style="gap:5px;align-items: center;"
            rel="noopener noreferrer">
            <i class="inverteIcone fa-sharp fa-solid fa-phone"></i>
            <span>(33) 3641-3038</span>
            </a>
          </div>
          <div class="d-lg-flex flex-row" style="gap:20px; display: none;" @click="irParaWpp()">
            <div aria-label="WhatsApp Primeseg" class="d-flex flex-row link" style="gap:5px;align-items: center;"
              rel="noopener noreferrer">
              <i class="fa-brands fa-whatsapp iconWpp"></i>
              <span>(33) 99733-8463</span>
            </div>
          </div>
        </div>

      <div class="d-flex flex-row" style="align-items: center;gap: 15px;">
        <a aria-label="Instagram Primeseg" href="https://www.instagram.com/primeseg.teo/">
          <i class=" redeSocial fa-brands fa-instagram"></i>
        </a>
      </div>
      </div>
    </div>
    <nav class="navbar navbar-expand-xl px-0 py-3">
      <div class="container-xl">
        <router-link aria-label="página inicial" to="/" class="w-25">
          <img src="../assets/logo.png" alt="logo" class="w-100" >
        </router-link>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse"
          aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation" >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
          <div class="navbar-nav mx-lg-auto">
            <router-link :aria-label="item.nome"  :class="item.ativo == true ? `color-black nav-item nav-link d-flex` : 'nav-item nav-link d-flex' "  :to="item.url" v-for="(item,index) in navBarItems" :key="index">
            <span class="w-100" :data-bs-toggle="tamanhoDaTela < 968 ? 'collapse' : null" data-bs-target="#navbarCollapse">
              {{item.nome}}
            </span>
            </router-link>
            </div>
          <div class="d-flex align-items-lg-center mt-3 mt-lg-0">
            <a style="min-width: 150px;" href="https://admin.clinicaprimeseg.com.br/#/login" class="btn btn-sm btn-primary w-full w-lg-auto">
              <i class="fa-solid fa-user"></i>
              Área do cliente
            </a>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  name: 'NavBar',
  props: ['navBar'],
  data () {
    return {
      navBarItems: this.navBar.items,
      tamanhoDaTela: window.innerWidth
    }
  },
  methods: {
    irParaWpp () {
      window.open('https://wa.me/5533997338463?text=Olá gostaria de um orçamento para minha empresa!', '_blank')
    }
  }
}
</script>
<style scoped>
.iconWpp{
  transform: scale(1.1);
}
@media screen and (max-width: 968px) {
 a{
  width: 75% !important;
 }
}
.color-black{
  color: black;
}
.fixed{
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
}
.navbar{
  background-color: var(--cor-terciaria);
  max-height:10% ;
}
.redeSocial {
  color:  var(--cor-terciaria);
  transform: scale(1.2);
  transition: all ease 0.4s;
}

.redeSocial:hover {
  color: var(--cor-secondaria);
}

.link {
  text-decoration: none;
  cursor: pointer;
  font-size: 18px;
  transition: all ease 0.5s;
  color: rgb(255, 255, 255) !important;
  font-weight: 500;
}

.nav-item {
  text-decoration: none;
  cursor: pointer;
  font-size: 18px;
  transition: all ease 0.5s !important;
}

.nav-item:hover {
  color: var(--cor-primaria) !important;
}

.inverteIcone {
  color: whitesmoke;
  transform: rotateY(180deg)
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue